import * as SurveyCore from 'survey-core';
import { StringEditorViewModelBase } from 'survey-creator-core';
import {
  isRangeSetStartError,
  patchSurveyCoreSanitize,
  sanitizeEditableContent,
} from './utils/sanitizeEditableContent';

let hasAppliedFix = false;

/**
 * Installs the contenteditable backspace guard before Survey Creator mounts.
 * Creator-core looks up survey-core.sanitizeEditableContent at call time, so
 * replacing that export (and wrapping onInput) stops the Range.setStart crash.
 *
 * @returns {void}
 */
export function applySurveyJsBackspaceFix() {
  if (hasAppliedFix) return;
  hasAppliedFix = true;

  patchSurveyCoreSanitize(SurveyCore);
  wrapStringEditorOnInput();
}

function wrapStringEditorOnInput() {
  const prototype = StringEditorViewModelBase && StringEditorViewModelBase.prototype;
  if (!prototype || typeof prototype.onInput !== 'function') return;
  if (prototype.__teseBackspacePatched) return;

  const originalOnInput = prototype.onInput;
  prototype.onInput = function onInputWithBackspaceGuard(event) {
    try {
      return originalOnInput.call(this, event);
    } catch (error) {
      if (!isRangeSetStartError(error)) {
        throw error;
      }
      const element = event && event.target;
      if (element) {
        sanitizeEditableContent(element);
      }
    }
  };
  prototype.__teseBackspacePatched = true;
}
